export default __webpack_public_path__ + "static/media/gb.09860552.svg";